// Records every onboarding submit attempt. A submit that dies on the device
// (offline, WebView killed) is queued here and reported on the next app open,
// so it can never vanish without a trace.
const QUEUE_KEY = 'bm_onboard_submit_log';
const API = process.env.REACT_APP_BACKEND_URL;

const readQueue = () => {
  try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]'); } catch { return []; }
};

const writeQueue = (items) => {
  try { localStorage.setItem(QUEUE_KEY, JSON.stringify(items.slice(-10))); } catch {}
};

async function post(record) {
  const token = localStorage.getItem('bodymax-token') || sessionStorage.getItem('bodymax-token');
  if (!token) throw new Error('no token');
  const res = await fetch(`${API}/api/onboarding/submit-report`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(record),
  });
  if (!res.ok) throw new Error(`report failed: ${res.status}`);
}

/** Queue first, then try to send: the queue is the thing that survives a dead network. */
export async function reportSubmit(record) {
  const entry = { ...record, client_at: new Date().toISOString(), offline: !navigator.onLine };
  const queue = readQueue();
  queue.push(entry);
  writeQueue(queue);
  try {
    await post(entry);
    writeQueue(readQueue().filter(q => q.client_at !== entry.client_at));
  } catch {}
}

/** Send anything that never made it off the device. Called when onboarding opens. */
export async function flushSubmitLog() {
  const queue = readQueue();
  if (!queue.length) return;
  const sent = [];
  for (const entry of queue) {
    try {
      await post({ ...entry, late_report: true });
      sent.push(entry.client_at);
    } catch { break; }
  }
  if (sent.length) writeQueue(readQueue().filter(q => !sent.includes(q.client_at)));
}

export function submitAttemptCount() {
  return readQueue().filter(q => q.outcome === 'attempted').length;
}
